import { Button, Input, Modal } from "antd";
import React, { useState } from "react";

interface Props {
  title: string;
  onConfirm: () => void;
}

export default function ConfirmDeleteCreationModal({
  title,
  onConfirm,
}: Props) {
  const [visible, setVisible] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const showModal = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const handleDelete = () => {
    onConfirm();
    setVisible(false);
  };

  return (
    <>
      <Button danger onClick={showModal}>
        DELETE
      </Button>
      <Modal
        // className="sub-heading-font"
        title={
          <span className="sub-heading-font">Delete Research Creation</span>
        }
        visible={visible}
        onOk={handleDelete}
        okButtonProps={{
          disabled: inputValue !== title.trim(),
          className: "sub-heading-font",
        }}
        okText="Delete"
        okType="danger"
        onCancel={handleCancel}
        cancelButtonProps={{
          className: "sub-heading-font",
        }}
      >
        <p>
          <strong>WARNING:</strong> The following Research Creation{" "}
          <strong>WILL BE DELETED PERMANENTLY: </strong>
          <em>{title}</em>
        </p>
        <p>
          To confirm delete, please type the title of the Research Creation
          below:
        </p>
        <Input
          placeholder="Title of Research Creation"
          onChange={(e) => {
            setInputValue(e.target.value);
          }}
        />
      </Modal>
    </>
  );
}
